<template>
    <div class="">
      <v-card class="flex-container mb-3 admin-container-temp" style="border-radius: 12px;">
       
  <v-toolbar class="shadow-none" style="flex: unset" content-class="h-auto">
      <div class="row" style="display: flex; justify-content: space-between" >
          <div class="col-4" style="display: flex">
              <div class="custom-icon-wrapper" style="display: inline-block"> <v-icon @click="backToAdminPage">custom-icon left-arrow-icon</v-icon> </div>
              <v-toolbar-title style="padding-top: 10px; display: inline" class="size-16 dark-text mx-5" >{{ $t("res_Label_ManageExternalEntities") }}</v-toolbar-title >
          </div> 
           <div class="col-1" style="display: flex; justify-content: flex-end">
              <v-btn color="primary" @click="OpenMergeForm()">{{ $t("res_ButtonText_Merge") }}</v-btn>
          </div>
      </div>
  </v-toolbar>
  
        
        <div class="border-top organization-management-dialog d-flex h-100">
          <div
              style="height: calc(85vh); max-height: calc(85vh)"
              class="tree-section col-md-4 col-lg-4 d-flex flex-column bg-white">
              <div class="d-flex gap-2">
                  <div class="flex-1">
                  <div class="search-bar-gray">
                      <v-btn @click="handleSearch()"><v-icon>mdi-magnify</v-icon></v-btn>
                <v-text-field v-model="searchVal" solo :label="$t('res_Label_SearchPlaceHolder')"
                  @keydown.enter="handleSearch()"></v-text-field>
                      <v-btn @click="clear()"><v-icon>mdi-close</v-icon></v-btn>
                  </div>
                  </div>
            <div class="custom-icon-wrapper" v-if="enableAddTopParnetStructure">
              <v-icon 
              @click="addParentStructure(null)">custom-icon plus-icon</v-icon> 
            </div>
              </div>
              <v-treeview
                  class="flex-1 overflow-auto"
                  dense
                  :active:sync="active"
                  :items="items"
                  ref="tree"
                  :load-children="fetchStructure"
                  :open="openNodes"
                  activatable
                  item-key="id"
                  color="success"
                  open-on-click 
                  transition
              >
                  <template v-slot:label="{ item }">
                  <div @contextmenu="show($event, item)" @click="openEdit(item)"
                        :style="{ fontWeight: currentSelectedItem === item ? 'bold' : 'normal'}">
                      {{ (language =='ar' && item.nameAr != '') ? item.nameAr :item.name }}
                  </div>    
                  </template>
                  <template v-slot:prepend="{ item, open }">
                    <div @contextmenu="show($event, item)">
                        <v-icon :style="(item.active == true ? '' : 'color:#bebebe !important')" v-if="item.children && item.id != 0">
                        {{ open ? 'mdi-chevron-down-circle' : 'mdi-chevron-right-circle' }}
                        </v-icon>
                        <v-icon v-else-if="item.id != 0">mdi-account</v-icon>
                        {{ item.text }}
                    </div>
                  </template>
              </v-treeview>
             
            <!--</div>-->
          </div> 

          <v-dialog v-model="add_edit_Structure" content-class="dialog bg-white w-40" scrollable>
            <!-- Add Edit -->
            <!--<v-container fluid class="m-0 p-0 h-100">-->
            <v-card class="h-100" v-if="add_edit_Structure" ref="AddEditStructure">
              <v-toolbar class="bg-white">
                    <v-card-title class="p-0"> {{ this.currentStructureName }} {{ this.currentStructureMode }}</v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="add_edit_Structure = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
  
              <div class="d-flex flex-column overflow-auto h-100">
                <div class="p-4 flex-grow-1 overflow-auto">          
                  <div class="mb-3-rem">
                    <label>{{ $t("res_Label_Code")}}</label>
                    <v-text-field
                      v-model="structureForm.code"
                      label=""
                      solo
                    ></v-text-field>
                  </div>
                  <div class="mb-3-rem">
                    <label class="">{{ $t("res_Label_Name")}}<span> *</span></label>
                    <v-text-field
                      v-model="structureForm.name"
                      :rules="rules"
                      label=""
                      solo
                    ></v-text-field>
                  </div>       
                  <div class="mb-3-rem">
                      <label>{{ $t("res_Label_NameAr")}}<span> *</span></label>
                      <v-text-field v-model="structureForm.nameAr"  label="" solo></v-text-field>
                  </div>
                  <div class="mb-3-rem">
                      <label>{{ $t("res_Label_Email") }}</label>
                      <v-text-field v-model="structureForm.email"  label="" solo></v-text-field>
                  </div>
                  <div class="mb-3-rem">
                      <label>{{ $t("res_Label_Phone") }}</label>
                      <v-text-field type="number" v-model="structureForm.phone"  label="" solo></v-text-field>
                  </div>
                  <div class="mb-3-rem">
                      <label>{{ $t("res_Label_Fax") }}</label>
                      <v-text-field type="number" v-model="structureForm.fax"  label="" solo></v-text-field>
                  </div>
                  <div class="mb-3-rem">
                      <label>{{ $t("res_Label_Country") }}</label>
                      <Multiselect class="light-bg add-arrow" v-model="structureForm.country" label="Name" :placeholder="$t('res_Label_SelectCountry')" track-by="Id" open-direction="bottom"
                    :options="countriesList" :searchable="false" :internal-search="false" :clear-on-select="false"
                    :close-on-select="true" :options-limit="300" :max-height="600" :show-no-results="false"
                    :hide-selected="false" :multiple="false">
                      </Multiselect>
                  </div>
                  <div class="mb-3-rem">
                      <label>{{ $t("res_Label_POBox") }}</label>
                        <v-text-field v-model="structureForm.poBox"  label="" solo></v-text-field>
                  </div>
                  <div class="mb-3-rem">
                    <label>{{ $t("res_Label_Description") }}</label>
                    <v-text-field v-model="structureForm.description"  label="" solo></v-text-field>
                  </div>
                  <div class="mb-3-rem">
                    <label>{{ $t("res_Label_Address") }}</label>
                    <v-text-field v-model="structureForm.address"  label="" solo></v-text-field>
                  </div>
                  <div class="d-flex" style="align-items: center;">
                    <label></label>
                    <v-checkbox v-model="structureForm.disableTransfers" :label="$t('res_Label_DisableTransfer') "></v-checkbox>
                  </div>
                  <!-- <div class="d-flex" style="align-items: center;">
                    <label></label>
                    <v-checkbox v-model="structureForm.allowExternalCommunication" :label="$t('res_Label_AllowExternalCommunication') "></v-checkbox>
                  </div> -->
                  <div class="mb-3-rem" v-if="structureForm.isCompany && constants.isFullAdmin && enableEntityConfiguration">
                      <label>{{ $t('res_Label_StorageDatabaseName') }}</label>
                      <v-text-field v-model="structureForm.storageDatabaseName" label="" solo></v-text-field>
                  </div>
                  <div class="mb-3-rem" v-if="structureForm.isCompany && constants.isFullAdmin && enableEntityConfiguration">
                      <label>{{ $t('res_Label_StorageFile') }}</label>
                      <v-text-field v-model="structureForm.storageFile" label="" solo></v-text-field>
                  </div>                      
                </div>
                <v-card-actions class="top-shadow gap-3">
                    <v-btn class="light-blue flex-1"  @click="add_edit_Structure = false">{{$t("res_ButtonText_Cancel")}}</v-btn>
                    <v-btn @click="handleSubmit" class="primary flex-1">{{ $t("res_ButtonText_Submit")}}</v-btn>
                </v-card-actions>
                </div>
            </v-card>
          </v-dialog >
  
          
          <div class="form-section col-md-8 col-lg-8 p-0 overflow-auto" style="height: calc(85vh); max-height: calc(85vh)" v-show="show_merge_Structure_Form">
                          <v-card class="h-100">
                              <div class="border-top p-4 flex-1 overflow-auto">
                                  <div class="row mb-1">
                                      <div class="col-12">
                                          {{ $t("res_Label_Source_ToBeRemoved") }}
                                      </div>
                                  </div>
                                  <div class="row mb-3 mt-0">
                                      <div class="col-2" style="display: block; margin: auto">
                                          {{ $t("res_Label_Source") }}*
                                      </div>
                                      <div class="col-4">
                                          <StructureUserSelector
                                              :showInternalUsers="false"
                                              :showExternalUsers="false"
                                              :showInternalStructures="false"
                                              :showExternalStructures="true"
                                              :excludeSelf="true"
                                              :isMultiple="false"
                                              :selectedStructureUser="toStructure_S"
                                              @structureUserSelectChanged="structureUserSelectChanged_S">
                                          </StructureUserSelector>
                                      </div>
                                      <div class="col-2" style="display: block; margin: auto">
                                          {{ $t("res_Label_Destination") }}*
                                      </div>
                                      <div class="col-4">
                                          <StructureUserSelector
                                              :showInternalUsers="false"
                                              :showInternalStructures="false"
                                              :showExternalStructures="true"
                                              :excludeSelf="true"
                                              :isMultiple="false"
                                              :selectedStructureUser="toStructure_D"
                                              @structureUserSelectChanged="structureUserSelectChanged_D">
                                          </StructureUserSelector>
                                      </div>
                                  </div> 
                                  <div class="actions d-flex">
                                      <v-btn @click="ConfirmMergeExternalStructures" color="primary" dense >
                                          {{ $t("res_ButtonText_Submit") }}
                                      </v-btn>
                                  </div>
                              </div>
                          </v-card>
          </div> 
  
          <v-menu
            v-model="showMenu"
            :position-x="x"
            :position-y="y"
            class="menu"
            :offset-y="offset"
            :close-on-content-click="false"
          >
            <v-list>
              <v-list-item
                v-for="(item, i) in menuItems"
                :key="i"
                @click="openOptionPane(item.id)"
              >
                <v-icon color="navy" v-text="item.icon"></v-icon
                >&nbsp;{{ item.title }}
              </v-list-item>
            </v-list>
          </v-menu>
        
        <div class="form-section col-md-8 col-lg-8 p-0 overflow-auto" style="height: calc(85vh); max-height: calc(85vh)"
            v-if="AddExternalUser"> 
            <v-card class="h-100" v-if="AddExternalUser" ref="AddExternalUser" style="padding-top: 30px;">
                <div>
                        <v-row>
                            <v-col cols="12" sm="4">
                                <label class="label_required">{{ $t('res_Label_FirstName') }}<span> *</span></label>
                                <v-text-field v-model="user.firstName" :placeholder="$t('res_Label_EnterFirstName')" class="light-bg ps-1" type="text"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <label class="label_required">{{ $t('res_Label_MiddleName') }}</label>
                                <v-text-field v-model="user.middleName" :placeholder="$t('res_Label_EnterMiddleName')" class="light-bg ps-1" type="text"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <label class="label_required">{{ $t('res_Label_LastName') }}<span> *</span></label>
                                <v-text-field v-model="user.lastName" :placeholder="$t('res_Label_EnterLastName')" class="light-bg ps-1" type="text"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="4">
                                <label class="label_required">{{ $t('res_Label_FirstNameAr') }}<span> *</span></label>
                                <v-text-field v-model="user.firstNameAr" :placeholder="$t('res_Label_EnterFirstNameArabic')" class="light-bg ps-1" type="text"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <label class="label_required">{{ $t('res_Label_MiddleNameAr') }}</label>
                                <v-text-field v-model="user.middleNameAr" :placeholder="$t('res_Label_EnterMiddleNameArabic')" class="light-bg ps-1" type="text"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <label class="label_required">{{ $t('res_Label_LastNameAr') }}<span> *</span></label>
                                <v-text-field v-model="user.lastNameAr" :placeholder="$t('res_Label_EnterLastNameArabic')" class="light-bg ps-1" type="text"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="4">
                                <label class="label_required">{{ $t('res_Label_Email') }}<span> </span></label>
                                <v-text-field v-model="user.email" :placeholder="$t('res_Label_EnterEmailAddress')" class="light-bg ps-1" type="text"></v-text-field>
                            </v-col>
                            <v-col >
                                <label class="label_required">{{ $t('res_Label_Profession') }}<span></span></label>
                                <textarea v-model="user.profession" rows="3" label="" :placeholder="$t('res_Label_EnterProfession')" solo class="customTextarea2 input-text-color"></textarea>
                            </v-col>
                            <v-col >
                                <label class="label_required">{{ $t('res_Label_ProfessionAr') }}<span></span></label>
                                <textarea v-model="user.professionAr" rows="3" label="" :placeholder="$t('res_Label_EnterProfessionArabic')" solo class="customTextarea2 input-text-color"></textarea>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="4">
                                <label class="label_required">{{ $t('res_Label_Title') }}<span></span></label>
                                <v-text-field v-model="user.title" :placeholder="$t('res_Label_EnterTitle')" class="light-bg ps-1" type="text"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <label class="label_required">{{ $t('res_Label_TitleAr') }}<span></span></label>
                                <v-text-field v-model="user.titleAr" :placeholder="$t('res_Label_EnterTitleArabic')" class="light-bg ps-1" type="text"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <label class="label_required">{{ $t('res_Label_Salutation') }}<span></span></label>
                                <v-text-field v-model="user.salutation" :placeholder="$t('res_Label_EnterSalutation')" class="light-bg ps-1" type="text"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-checkbox v-model="user.active" :label="$t('res_CheckBox_Active')"></v-checkbox>
                            </v-col>
                        </v-row>
                        <v-row>
                        <v-col cols="12" sm="4" class="d-flex gap-2">
                            <v-btn color="primary" @click="CancelDesignatedUser" width="100">{{ $t("res_ButtonText_Cancel") }}</v-btn>
                            <v-btn @click="upsertUser" color="primary" style="margin-left:25px;" width="100">{{ $t("res_ButtonText_Continue") }}</v-btn>
                        </v-col>
                        </v-row>
                    </div>
            </v-card>
          </div>

          <div v-if="showListUsers" class="form-section col-md-8 col-lg-8 p-0 overflow-auto" style="height: calc(85vh); max-height: calc(85vh)"> 
            <v-card class="h-100"   style="padding-top: 30px;">
              <div  class="mt-4" :class="{ 'ml-10 mr-4': lang == 'en' || lang == null, 'mr-10 ml-4': lang == 'ar' }">
                  <div class="d-flex mt-3 bg-gray text-white rounded-3" style="background-color: #7DA1C4">
                      <span style="width:40px"></span>
                      <!-- <span class="col-1">{{ utils.SwitchByLang($t("res_GridHeaders_UserStatus"),$t("res_GridHeaders_UserStatusAr")) }}</span> -->
                      <span class="col-xl">{{ utils.SwitchByLang($t("res_Label_FirstName"),$t("res_Label_FirstNameAr")) }}</span>
                      <span class="col-xl">{{ utils.SwitchByLang($t("res_Label_MiddleName"),$t("res_Label_MiddleNameAr")) }}</span>
                      <span class="col-xl">{{ utils.SwitchByLang($t("res_Label_LastName"),$t("res_Label_LastNameAr")) }}</span>
                      <span class="col-xl">{{ $t("res_Label_Email") }}</span>
                      <span class="col-xl">{{ utils.SwitchByLang($t("res_Label_Title"),$t("res_Label_TitleAr")) }}</span>
                      <span class="col-xl">{{ utils.SwitchByLang($t("res_Label_Profession"),$t("res_Label_ProfessionAr")) }}</span>
                      
                  </div>
                  <div v-if="sendingDesignatedPersonsList.length==0" class="justify-content-center d-flex m-2 mt-6 rounded-3 ml-14">
                      <span class="align-items-center weight-500">{{ $t("res_Label_NoData") }}</span>
                  </div>
                  <!--Data Of children-->
                  <div class="d-flex rounded-3"  v-else
                       v-for="(person,index) in sendingDesignatedPersonsList">
                      <span class="d-flex justify-content-center align-items-center" style="width: 40px; height: 40px;">
                          <v-checkbox @click="handleDesignatedPersonCheckboxClick(person)" v-model="person.isSelected" class="bg-white"></v-checkbox>
                      </span>
                      <!-- <span class="col-1">
                            <v-icon :style="{ color: person.active ? '#008000' : '#F44336' }" class="mr-2">mdi-account</v-icon>
                      </span> -->
                      <span class="col-xl text-cut">
                        <v-icon :style="{ color: person.active ? '#008000' : '#F44336' }" class="mr-2">mdi-account-box-outline</v-icon>
                        {{ utils.SwitchByLang(person.firstName,person.firstNameAr) }}</span>
                      <span class="col-xl text-cut">{{ utils.SwitchByLang(person.middleName,person.middleNameAr) }}</span>
                      <span class="col-xl text-cut">{{ utils.SwitchByLang(person.lastName,person.lastNameAr) }}</span>
                      <span class="col-xl text-cut">{{ person.email}}</span>
                      <span class="col-xl text-cut">{{ utils.SwitchByLang(person.title,person.titleAr) }}</span>
                      <span class="col-xl text-cut">{{ utils.SwitchByLang(person.profession,person.professionAr) }}</span>
                      <div  class="p-2 d-flex justify-center" style="width:75px">
                          <button class=""
                                  @click="showAddEditDialog(person)">
                              <v-icon class="light">mdi-pencil</v-icon>
                          </button>
                      </div>
                  </div>
              </div>
              </v-card>
          </div>
  
      </div>
      </v-card>


      <v-dialog v-model="parentStructureDialog"  max-width="500"  width="50%" class="visible-overflow my-custom-dialog" >
			<v-card>
				<v-toolbar class="bg-white">
					<v-card-title class="p-0">{{ $t("res_Label_SelectStructure") }}</v-card-title>
					<v-spacer></v-spacer>
					<v-btn class="close-btn light-btn" icon dark @click="parentStructureDialog = false" >
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-toolbar>  
				<v-card-text class="mt-4" >
                    <v-label>{{ $t("res_Label_Structure") }}*</v-label>  
                    <StructureUserSelector
                            :showInternalUsers="false"
                            :showExternalUsers="false"
                            :showInternalStructures="false"
                            :showExternalStructures="true"
                            :excludeSelf="true"
                            :isMultiple="false"
                            :fixDropdownStyle="fixDropdownStyle"
                            :selectedStructureUser="newParentStructure"
                            :disableOtherInternalEntitiesAsExternal="true"
                            @structureUserSelectChanged="newParentStructureSelectChanged">
                    </StructureUserSelector>
                </v-card-text>
				<v-card-actions class="gap-2 sticky-actions">
					<v-spacer></v-spacer> 
                    <v-btn style="width: 100px" class="light-blue" @click="parentStructureDialog = false">{{ $t("res_ButtonText_Cancel") }}</v-btn>
					<v-btn style="width: 100px" class="primary" @click="changeStructureParent()">
                        {{ $t("res_ButtonText_Submit") }} 
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog> 
         
    </div>
  </template>
      
  <script>
    import axios from 'axios'
    import router from '@/router/index.js'
    import constants from '@/assets/js/constants'
    import Multiselect from 'vue-multiselect'
    import SendSignRule from '@/components/SendSignRule.vue'
    import AutoForward from '@/components/AutoForward.vue'
    import TemplateDelegate from '@/components/TemplateDelegate.vue'
    import ManageTemplate from '@/components/ManageTemplate.vue'
    import * as utils from '@/assets/js/common.js'
    import StructureUserSelector from "@/components/StructureUserSelector.vue"; 
  export default {
      name: 'OrgManagement',
      components: { Multiselect, SendSignRule, AutoForward, TemplateDelegate, ManageTemplate , StructureUserSelector},
      data() {
          return {
            pagingData: {
                pageIndex: 0,
                pageSize: 100,
            },
            constants: constants,
            countriesList: [],
            parentStructureDialog: false,
            newParentStructure_Id: 0,
            newParentStructure: null, 
            dialog: false,
            structureIdForChangeParent:0,
            showPopup: false,
            transfer_user: false,
            showListUsers: false,
            toStructure_SId: 0,
            toStructure_S: null,
            toStructure_DId: 0,
            toStructure_D: null,
            showUpdateStructureUserBtn: false,
            sendingDesignatedPersonsList:[],
            language:'en',
            show1: false,
            offset: true,
            password: 'Password',
            active: [],
            currentUserId: 1,
            utils: utils,
            selectedStructureId: 1,
            selectedParentId: 0,
            currentStructureName: '',
            currentStructureMode: '',
            userId: '',
            exceptionUsers: [],
            managers: [],
            selectedUsers: [],
            selectedStructureUserIds: [],
            uploadedFile: [],
            structureForm: {
                code: '',
                name: '',
                manager: [],
                nameFr: '',
                nameAr: '',
                external: true,
                active: true,
                disableTransfers : false ,
                document_date_menu: false,
                date: '',
                isCompany:false,
                storageDatabaseName:'',
                storageFile:'',
                email: '',
                phone: '',
                fax: '',
                country: {},
                poBox: '',
                description: '',
                address: '',
                allowExternalCommunication: true
            },
        
            structureData: {
                structureDataArray: []
            },

            image: null,
            showMenu: false,
            isEdit: false,
            loading: false,
            showUsers: false,
            showManageTemplates: false,
            searchVal: '',

            rules: [
                value => !!value || 'This value is required.',
                value => (value && value.length >= 1),
            ],

            structureHeaders: [
                { text: 'Id', value: 'id', sortable: false, align: ' d-none'},
                { text: 'Structure Name', value: 'structure', sortable: false },
                { text: 'Privacy Level', value: 'privacyLevel', sortable: false },
                { text: 'Contact Role', value: 'contactRole', sortable: false },
                { text: 'Profession', value: 'profession', sortable: false },
                { text: 'Profession Ar', value: 'ProfessionAr', sortable: false },
                { text: 'Structure Receiver', value: 'isStructureReceiver', sortable: false },
                { text: 'Designated Person', value: 'isDesignatedPerson', sortable: false },
            ],
            systemRoles: [
                { text: 'Administrator', value: 1 },
                { text: 'User', value: 2 }
            ],
            genders: [
                { text: 'Male', value: 'M' },
                { text: 'Female', value: 'F' }
            ],
            privacy_items: [],
            contactRoles: [],
        
            items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
            x: 0,
            y: 0,
            menuItemsForParent:[
                {
                    id: 4,
                    title: this.$t("res_MenuItem_Add_structure"),
                    icon: 'mdi-plus-box'
                },
                {
                    id: 11,
                    title: this.$t("res_MenuItem_Add_User"),
                    icon: 'mdi-account',
                },
                {
                    id: 12,
                    title: this.$t("res_MenuItem_show_User"),
                    icon: 'mdi-eye-outline',
                },
                {
                    id: 13,
                    title: this.$t("res_MenuItem_Transfer_structure"),
                    icon: 'mdi-repeat',
                }
            ],
            menuItemsForChiled: [
                {
                    id: 4,
                    title: this.$t("res_MenuItem_Add"),
                    icon: 'mdi-plus-box'
                },
                {
                    id: 5,
                    title: this.$t("res_MenuItem_Edit"),
                    icon: 'mdi-pencil-box-outline'
                },
                {
                    id: 6,
                    title: this.$t("res_MenuItem_Delete"),
                    icon: 'mdi-minus-circle'
                },
                {
                    id: 8,    
                    title: this.$t("res_MenuItem_ActiveStructure"),
                    icon:   'mdi-play-circle' , 
                },
                {
                    id: 11,
                    title: this.$t("res_MenuItem_Add_User"),
                    icon: 'mdi-account',
                },
                {
                    id: 12,
                    title: this.$t("res_MenuItem_show_User"),
                    icon: 'mdi-eye-outline',
                },
                {
                    id: 13,
                    title: this.$t("res_MenuItem_Transfer_structure"),
                    icon: 'mdi-repeat',
                }
            ],
            user: {
                structureId: 0,
                isDefaultDesignatedPerson:true
            },
            AddExternalUser:false,
            menuItems: [],
            items: [],
            openNodes: [],
            clickedUser: true,
            clickedWindow: false,
            showList: false,
            delegateKey: 0,
            show_merge_Structure_Form: false,
            add_edit_Structure: false,
            editStructureDialog: false,
            addUser: false,
            userMetadata: false,
            disableFields: false,
            disableMailField: false,
            showStructures: false,
            showApplications: false,
            isSubmit: true,
            sendStructureIdProp: 0,
            autoForwardKey: 0,
            templateDelagationKey: 0,
            sendSignRuleKey: 0,
            templatKey: 0,
            constants: constants,
            enableEntityConfiguration: admin_enableEntityConfiguration,
            enableAddTopParnetStructure : false,
            currentSelectedItem: null,
          };
      },
      watch: {
          uploadedFile(newSource, oldSource) {
              if (newSource != oldSource) {
                  var binaryData = [];
                  binaryData.push(newSource);
                  this.image = URL.createObjectURL(new Blob(binaryData, { type: "image/png" }))
              }
          },
      },
      mounted() 
      {
          this.asyncFindExceptionUser("")
          this.asyncStructuresTreeView()
          this.getConstantData()
          this.getDesignatedPerson()
          this.language = localStorage.getItem('lang');
          //this.structureForm.country = { Id: 0, Name: this.$t("res_Label_SelectCountry") }
          eval(admin_enableEntityConfiguration)
          if(constants.isFullAdmin){
              this.enableAddTopParnetStructure = true;
          }
      },
      methods:
      {
        fixDropdownStyle() {
            console.log('fixDropdownStyle');
            var dropdown = document.querySelectorAll('.v-dialog.v-dialog--active');
            for (const item of dropdown) {
                item.style.overflow = 'visible';
            }
        },
        async changeStructureParent(){ 
            if(this.newParentStructure_Id == null || this.newParentStructure_Id == 0)
            { 
                window.showAlert('res_Label_ValidationOnParentStructure', 'warning'); 
                return;
            }

            if(this.selectedStructureId == this.newParentStructure_Id)
            { 
                window.showAlert('res_Msgs_CantChangeParentToItself', 'warning');
                return;
            }
            
            const result = await axios.post(constants.baseApiUrl + `StructureUser/ChangeParentStructure?newParentId=${this.newParentStructure_Id}&structureId=${this.selectedStructureId}`);
            if (result.data && result.data.success == true)
            {
                window.showAlert('res_Msgs_StructureUpdated', 'success');
                this.asyncStructuresTreeView();
                this.parentStructureDialog = false;
            }
            else
            {   window.showAlert('res_Msgs_ChangeError', 'warning');}  
        },

        closeDialog() {
            this.dialog = false;
        },
          showAddEditDialog(stucture, structureId) 
          {
              this.user = { ...stucture };
              this.showListUsers = false;
              this.AddExternalUser =true;
          },
          getDesignatedPerson(){
              this.sendingDesignatedPersonsList = []
              axios.get(constants.baseApiUrl + 'Document/GetDesignatedPersons?structureIds=' + this.selectedStructureId
                                                  + '&search=&personsIds=&internalExternalBothCase=1&getAll=true&FromAdminPage=true' )
                      .then((res) => 
                      {
                          if ((res.data == null || res.data.length == 0))
                              return;
                              this.sendingDesignatedPersonsList = res.data;
                      })
                      .catch(error => console.log(error))
          },
          loadChildData(e){
              alert('Expanded')
          },
          async readFile(file, successHandler) 
          {
              var reader = new FileReader();
                  var fileByteArray = [];
                  reader.readAsArrayBuffer(file);
                  reader.onloadend = function (evt) {
                      if (evt.target.readyState == FileReader.DONE) 
                      {
                          var arrayBuffer = evt.target.result,
                              array = new Uint8Array(arrayBuffer);
                          for (var i = 0; i < array.length; i++) 
                          {
                              fileByteArray.push(array[i]);
                          }
                          
                          successHandler(fileByteArray);
                      }
                  }
          },
          getConstantData()
          {
              this.privacy_items = constants.privacies;
              this.contactRoles = constants.contactRoles;
          },
          backToAdminPage(){
              router.push({ name: 'admin' })
          },
          showEditStructureUserData(item)
          {
              this.showUpdateStructureUserBtn = true;
              this.structureData.structure = {name: item.structure, id: item.id};
              this.structureData.structureDisable = true;
              this.structureData.contactRole = this.contactRoles.find(x => x.name == item.contactRole);
              this.structureData.privacyLevel =  this.privacy_items.find(x => x.name == item.privacyLevel);
              this.structureData.profession = item.profession;
              this.structureData.professionAr = item.ProfessionAr;
              this.structureData.isStructureReceiver = item.isStructureReceiver;
              this.structureData.isDesignatedPerson = item.isDesignatedPerson;
          },
          handleSearch: function () 
          {
              if (this.searchVal != "") 
              { 
                  window.showLoading()
                  var params = "?search=" + this.searchVal;
                  axios.get(constants.baseApiUrl + 'Admin/GetAllStructuresForManageExternals' + params, { headers: constants.headers })
                      .then(res => 
                      {
                          if (res.data != null)
                          {
                              this.openNodes = []
                              this.items = res.data;
                               this.items.forEach(ele => {
                                  this.insertion(ele);
                              });
  
                              if (this.items.length > 0) {
                                  this.$refs.tree.updateAll(true);
                              }
                          }
                      })
                      .catch(err => console.warn(err))
                      .finally(() => window.hideLoading());
              }
              else 
              {
                  this.asyncStructuresTreeView();
              }
          },
          clear() 
          {
              this.searchVal = '';
              this.items = [];
              this.openNodes = [];
              this.asyncStructuresTreeView();
          },
          insertion: function (ele) {
              ele.isUser = ele.userId != null
              ele.isChild = true
              ele.position = ele.position
  
              this.openNodes.push(ele.id)
              if (ele.children.length > 0) {
                  ele.children.forEach(item => {
                      this.insertion(item)
                  });
              }
          },
          async asyncStructuresTreeView() 
          { 
                this.items = [];
                window.showLoading()
                axios.get(`${constants.baseApiUrl}Admin/GetAllStructuresForManageExternals`)
                .then((res) => 
                {
                    if (res.data != null)
                    {
                        res.data.forEach(element => {
                            var isParent = false;
                            if(element.parentId == null) isParent = true;
                            var item = {
                                id: element.id,
                                name: element.name,
                                nameAr:element.nameAr,
                                children: [],
                                isParent: isParent,
                                active: element.active
                            };
                            this.items.push(item);
                        });
                        var loadMore = this.items.find(x => x.id == 0) 
                        if(!loadMore)
                            this.items.push({
                                id: 0,
                                name: '...',
                                children: [],
                                isParent: true,
                                active: true
                            });
                    }
                }).catch(err => console.warn(err))
                .finally(() => window.hideLoading());
          },
          DelegationTemplateRender: function () 
          {
              this.showTemplateDelegation = true;
              this.sendStructureIdProp = this.selectedStructureId
          },
          asyncFindExceptionUser(query) {
              var methodUrl = 'StructureUser/search?showUsers=true&showInternalStructures=false&showExternalStructures=false&disableOtherInternalEntitiesAsExternal=true&search=';
  
              axios.get(constants.baseApiUrl + methodUrl + query, { headers: constants.headers })
                  .then(res => 
                  {
                      if(res.data != null)
                      {
                          this.exceptionUsers = res.data
                      }
                  })
                  .catch(err => console.warn(err))
          },
          async fetchStructure(item) 
          {    
               if(item.id == 0)
               {
                   return;
               }
               
              return axios.get(constants.baseApiUrl + 'Admin/GetAllStructuresForManageExternals?parentId=' + item.id, { headers: constants.headers })
                  .then(res => 
                  {
                      if (res.data != null)
                      {
                          var jsonObjects = [];
                          res.data.forEach(element => {
                              var isParent = false;
                              if(element.parentId == null) isParent = true;
                              var childItem = {
                                  id: element.id,
                                  name: element.name,
                                  nameAr:element.nameAr,
                                  children: [],
                                  isParent: isParent,
                                  active: element.active
                              };
                              jsonObjects.push(childItem);
                          });
                      }
                      item.children.push(...jsonObjects);
                  })
                  .catch(err => console.warn(err))
          },
          getSelectedStructureData(id)
          {
            window.showLoading();
            return axios.get(constants.baseApiUrl + 'StructureUser/GetSelectedStructure?ids=' + id.toString(), { headers: constants.headers })
                .then(res => 
                {
                    if (res.data != null)
                    {
                    this.structureForm.code = res.data[0].code
                    this.structureForm.name = res.data[0].name
                    this.structureForm.nameAr = res.data[0].nameAr
                    this.structureForm.external = true;
                    this.structureForm.isCompany=res.data[0].isCompany
                    this.structureForm.storageDatabaseName=res.data[0].storageDatabaseName
                    this.structureForm.storageFile=res.data[0].storageFile
                    this.structureForm.disableTransfers = res.data[0].disableTransfers
                    this.structureForm.allowExternalCommunication = res.data[0].allowExternalCommunication
                    this.structureForm.active = res.data[0].active
                    this.structureForm.email = res.data[0].email
                    this.structureForm.phone = res.data[0].phone
                    this.structureForm.fax = res.data[0].fax
                    var selectedCountry = null;
                    if (this.countriesList && Array.isArray(this.countriesList) && res.data[0].country) {
                        selectedCountry = this.countriesList.find(x => x.Id == res.data[0].country)
                    }
                    this.structureForm.country = selectedCountry || { Id: 0, Name: this.$t("res_Label_SelectCountry") }
                    this.structureForm.poBox = res.data[0].poBox
                    this.structureForm.description = res.data[0].description
                    this.structureForm.address = res.data[0].address
                    // Only set parent ID if it exists in the response, otherwise preserve existing value
                    if (res.data[0].structureParentId !== null && res.data[0].structureParentId !== undefined) {
                        this.selectedParentId = res.data[0].structureParentId
                    }
                    console.log("getSelectedStructureData -> selectedParentId: " + this.selectedParentId)
                    this.structureForm.manager = { id: res.data[0].managerId, name: res.data[0].managerName }
                    }
                })
                .catch(err => console.warn(err)).finally(() => window.hideLoading());
          },
          show(e, item) 
          {
              this.currentSelectedItem = item;
              if(item.isParent){
                  this.menuItems = !constants.isFullAdmin ? this.menuItemsForParent.filter(x => x.id ==  4) : this.menuItemsForParent
              }
              else{
                  this.menuItems = this.menuItemsForChiled
              }
              e.preventDefault()
              this.selectedStructureId = item.id
              this.showMenu = false
              this.currentStructureName = item.name
              this.x = e.clientX
              this.y = e.clientY
              this.$nextTick(() => {
                  this.showMenu = true
              })
          },
          openEdit(item)
          {
            if(constants.isFullAdmin)
            {
                if (item.id == 0) {
                    window.showAlert('You reached the view limit please search for the structure you want to view', 'warning');
                    return
                }
                this.selectedStructureId = item.id;
                this.currentStructureName = item.name;
                this.openOptionPane(5);
            }
          },
          resetFiles() 
          {
            this.structureForm.code = ''
            this.structureForm.name = ''
            this.structureForm.nameAr = ''
            this.structureForm.nameFr = ''
            this.structureForm.manager = []
            this.structureForm.external = true
            this.structureForm.isCompany = false
            this.structureForm.storageDatabaseName = ''
            this.structureForm.storageFile = '' 
            this.structureForm.disableTransfers = false
            this.structureForm.allowExternalCommunication = true
            this.structureForm.active = true
            this.structureForm.email = ''
            this.structureForm.phone = ''
            this.structureForm.fax = ''
            this.structureForm.country = { Id: 0, Name: this.$t("res_Label_SelectCountry") }
            this.structureForm.poBox = ''
            this.structureForm.description = ''
            this.structureForm.address = ''
          },
          isValidForm() {
              if (this.structureForm.name.trim() == '' || this.structureForm.nameAr.trim() == '') {
                  window.showAlert(this.$t("res_Msgs_FillRequired"), 'warning')
                  return false
              }
              return true
          },
          async handleSubmit() {
            if (!this.isValidForm()) {
                return
            }
            if(this.structureForm.phone < 0 || this.structureForm.fax < 0)
            {
                var message = this.structureForm.phone < 0 && this.structureForm.fax < 0 ? "phone number and fax both " : this.structureForm.phone < 0 ? 
                    "phone number" : "fax"
                window.showAlert(this.$t("res_Msgs_EnterAPositiveNumber").replace('{0}',  message), 'warning');
            }
            else 
            {
                let existingStructure = await this.checkExistence(this.structureForm.name, this.structureForm.nameAr);
                if (existingStructure == '')
                {
                    await this.submitData();
                    window.hideLoading();
                }
                else
                {
                    window.showInformation(this.$t("res_Msgs_Confirmation"), this.$t("res_Msgs_WarningCannotAddSameStructure").replace('{0}',  existingStructure),
                    async () => 
                    { 
                        await this.submitData();
                        window.hideLoading();
                    },
                    () => 
                    { window.hideLoading(); })
                }
            }
            window.hideLoading();
        }, 
        async checkExistence(nameEn, nameAr) 
        {
            const response = await axios.get(`${constants.baseApiUrl}StructureUser/CheckStructureExistence?nameEn=${nameEn}&nameAr=${nameAr}`); 
            return response.data;
        },
        async submitData()  
        {
            if (this.isEdit) 
            {
                if (this.structureForm.name && this.structureForm.nameAr) 
                {
                    if(this.structureForm.email != null && this.structureForm.email != '' && !utils.isValidEmail(this.structureForm.email))
                    {
                        window.showAlert('res_Msgs_InvalidEmail', 'warning')
                        return;
                    }

                    // For editing, use the loaded parent ID (selectedParentId), or null to preserve existing parent
                    var parentIdToSend = (this.selectedParentId && this.selectedParentId !== 0) ? this.selectedParentId : null;

                    var updateStructure = {
                        id: this.selectedStructureId,
                        Code: this.structureForm.code,
                        Name: this.structureForm.name,
                        NameAr: this.structureForm.nameAr,
                        StructureParentId: parentIdToSend,
                        ModifiedDate: Date.now,
                        External: true,
                        IsCompany: this.structureForm.isCompany,
                        StorageDatabaseName: this.structureForm.storageDatabaseName,
                        StorageFile: this.structureForm.storageFile,
                        DisableTransfers: this.structureForm.disableTransfers,
                        AllowExternalCommunication: this.structureForm.allowExternalCommunication,
                        Active: this.structureForm.active,
                        Email: this.structureForm.email,
                        Phone: this.structureForm.phone,
                        Fax: this.structureForm.fax,
                        Country: this.structureForm.country?.Id,
                        PoBox: this.structureForm.poBox,
                        Description: this.structureForm.description,
                        Address: this.structureForm.address
                    }

                    console.log("updateStructure: ")
                    console.log(updateStructure)

                    console.log("selectedParentId: ")
                    console.log(this.selectedParentId)
                    
                    window.showLoading();
                    axios.post(constants.baseApiUrl + 'StructureUser/UpdateStructureForTreeView', updateStructure, { headers: constants.headers })
                        .then(res => 
                        {
                            if (res.data != null)
                            {
                                window.showAlert('res_Msgs_StructureUpdated', 'success')
                                this.clearAddEditStructureFields()
                                this.asyncStructuresTreeView()
                            }
                        }).catch(err => console.warn(err))
                        .finally(()=>{window.hideLoading();})
                }
                else
                    window.showAlert('res_Msgs_FillRequired', 'warning')
            }
            else 
            {
                if (this.structureForm.name && this.structureForm.nameAr) 
                {
                    if(this.structureForm.email != null && this.structureForm.email != '' && !utils.isValidEmail(this.structureForm.email))
                    {
                        window.showAlert('res_Msgs_InvalidEmail', 'warning')
                        return;
                    }
                    
                    var addNewStructureBody = {
                        Code: this.structureForm.code,
                        Name: this.structureForm.name,
                        NameAr: this.structureForm.nameAr,
                        StructureParentId: this.selectedStructureId,
                        CreatedDate: Date.now,
                        External: true,
                        IsCompany: this.structureForm.isCompany,
                        StorageDatabaseName: this.structureForm.storageDatabaseName,
                        StorageFile: this.structureForm.storageFile,
                        DisableTransfers: this.structureForm.disableTransfers,
                        AllowExternalCommunication: this.structureForm.allowExternalCommunication,
                        Active: this.structureForm.active,
                        Email: this.structureForm.email,
                        Phone: this.structureForm.phone,
                        Fax: this.structureForm.fax,
                        Country: this.structureForm.country.Id,
                        PoBox: this.structureForm.poBox,
                        Description: this.structureForm.description,
                        Address: this.structureForm.address
                    }

                    window.showLoading();
                    axios.post(constants.baseApiUrl + 'StructureUser/AddStructureForTreeView', addNewStructureBody, { headers: constants.headers })
                        .then(res => 
                        {
                            if (res.data != null)
                            {
                                window.showAlert('res_Msgs_StructureAdded', 'success')
                                this.clearAddEditStructureFields()
                                this.asyncStructuresTreeView()
                            }
                        }).catch(err => console.warn(err))
                        .finally(()=>{window.hideLoading();})
                }
                else
                    window.showAlert('res_Msgs_FillRequired', 'warning')
            }
        },
        clearAddEditStructureFields()
        {
            this.add_edit_Structure = false
            this.structureForm.code = ''
            this.structureForm.name = ''
            this.structureForm.nameAr = ''
            this.structureForm.external = true
            this.selectedParentId = 0
            this.structureForm.isCompany = false,
            this.structureForm.storageDatabaseName = ''
            this.structureForm.storageFile = ''
            this.structureForm.disableTransfers = false
            this.structureForm.allowExternalCommunication = true
            this.structureForm.active = true
            this.structureForm.email = ''
            this.structureForm.phone = ''
            this.structureForm.fax = ''
            this.structureForm.country = { Id: 0, Name: this.$t("res_Label_SelectCountry") }
            this.structureForm.poBox = ''
            this.structureForm.description = ''
            this.structureForm.address = ''
        },
        CapitalizeFirstLetter(str)
        {
            return utils.CapitalizeFirstLetter(str)
        },
        GetMultiSelectSubHeaderDisplay(options)
        {
            return utils.GetMultiSelectSubHeaderDisplay(options)
        },
        addParentStructure(parentId){
            this.selectedStructureId = parentId;
            this.currentStructureMode = '';
            this.openOptionPane(4)
        },
        openOptionPane(id) 
        {
            this.showMenu = false;
            if (id == 4) 
            {
                this.isEdit = false;
                this.footer = false;
                this.resetFiles()
                this.currentStructureMode = ' / (' + this.$t('res_Label_NewStructure') +')'
                this.showListUsers = false
                this.add_edit_Structure = true;
                this.countriesList = constants.countriesList;
            }
            else if (id == 5) 
            {
                this.showAutoForwardPane = false;
                this.showSignSendPane = false;
                this.showTemplateDelegation = false;
                this.isEdit = true;
                this.showUsername = false;
                this.footer = false;
                this.showManageTemplates = false;
                this.countriesList = constants.countriesList;
                this.getSelectedStructureData(this.selectedStructureId);
                this.currentStructureMode = ' / (' + this.$t('res_Label_EditStructure') + ')'
                this.add_edit_Structure = true;
            }
            else if (id == 6) 
            {  
                window.showInformation(this.$t("res_Msg_DeleteConfirmation"), this.$t("res_Msgs_DeleteItemStructureDepartment"),
                    () => 
                    { 
                        window.showLoading();
                        axios.get(constants.baseApiUrl + 'StructureUser/DeleteStructureForTreeView?structureId=' + this.selectedStructureId, { headers: constants.headers })
                            .then(res => 
                            {
                                if (res.data != null && res.data == true)
                                {
                                    window.showAlert('res_Msgs_StructureDeleted', 'success')
                                    this.asyncStructuresTreeView()
                                }
                                else
                                {
                                    window.showAlert('res_Msgs_StructureDeleteViolation', 'warning')
                                }
                            })
                            .catch(err => console.warn(err))
                            .finally(()=>{window.hideLoading();})
                    },
                    () => 
                    { })
            }
            else if (id == 8)
            {
            window.showLoading();
            axios.get(constants.baseApiUrl + 'StructureUser/ToggleActiveStructure?structureId=' + this.selectedStructureId, { headers: constants.headers })
                .then(res => 
                {
                    if (res.data != null && res.data.success)
                    {
                        window.showAlert(res.data.message, 'success')
                        this.asyncStructuresTreeView();
                    }
                    else
                    {
                        window.showAlert((res.data != null && res.data.message != '' ? res.data.message : 'res_Msgs_StructureActiveDeactiveViolation'), 'warning')
                    }
                })
                .catch(err => console.warn(err))
                .finally(()=>{window.hideLoading();})
            }
            else if (id == 11)
            { 
                this.add_edit_Structure = false;
                this.show_merge_Structure_Form =false;
                this.AddExternalUser= true;
                this.showListUsers = false
                this.user={}
                this.user.active = true;
                this.user.structureId=this.selectedStructureId;
            }
            else if (id == 12)
            { 
                this.add_edit_Structure = false;
                this.show_merge_Structure_Form =false;
                this.AddExternalUser= false;
                this.showListUsers = true
                this.user.structure={id:this.selectedStructureId};
                this.getDesignatedPerson()
            }
            
            else if (id == 13)
            {
                this.add_edit_Structure = false;
                this.show_merge_Structure_Form =false;
                this.AddExternalUser= false;
                this.showListUsers = false;
                this.parentStructureDialog = true; 
                this.newParentStructure = null;
                this.getSelectedStructureData(this.selectedStructureId);
            }
        }, 
        async ConfirmMergeExternalStructures() {
            if (this.toStructure_DId <= 0 ||
                this.toStructure_SId <= 0 ||
                this.toStructure_DId == null ||
                this.toStructure_SId == null) {
                window.showAlert(
                    this.$t("res_Msgs_FillRequired"),
                    "warning"
                );
                return;
            }
            window.showInformation(
                this.$t("res_Label_Alert"),
                this.$t("res_Msgs_ConfirmMergeExternalStructures"),
                () => {
                    this.MergeExternalStructures();
                },
                () => {}
            );
        },
        async MergeExternalStructures() {
            try {
                const response = await axios.put(
                    `${constants.baseApiUrl}admin/ExternalEntities?DestinationId=${this.toStructure_DId}&SourceId=${this.toStructure_SId}`
                );
                if (
                    response &&
                    response.data &&
                    response.data.success == true
                ) {
                    window.showAlert(
                        this.$t("res_Label_MergeSucess"),
                        "success"
                    );
                    this.clearMergeExternalStructuresForm();
                    this.clearAddEditStructureFields();
                    this.asyncStructuresTreeView();
                } else {
                    if (
                        response &&
                        response.data &&
                        response.data.message != ""
                    ) {
                        window.showAlert(this.$t(response.data.message));
                    } else {
                        window.showAlert(
                            this.$t("res_Label_MergeFail"),
                            "error"
                        );
                    }
                }
            } catch (error) {
                console.error("Error:", error);
            }
        },
        clearMergeExternalStructuresForm() { 
            this.show_merge_Structure_Form = false;
            this.toStructure_S = null;
            this.toStructure_D = null;
            this.toStructure_SId = 0;
            this.toStructure_DId = 0;
        },
        structureUserSelectChanged_S(selectedItem) {
            if (selectedItem) {
                this.toStructure_S = selectedItem;
                this.toStructure_SId = selectedItem.id;
            } else {
                this.toStructure_S = null;
                this.toStructure_SId = 0;
            }
        },
        structureUserSelectChanged_D(selectedItem) {
            if (selectedItem) {
                this.toStructure_D = selectedItem;
                this.toStructure_DId = selectedItem.id;
            } else {
                this.toStructure_D = null;
                this.toStructure_DId = 0;
            }
        },
        OpenMergeForm()
        { 
            this.show_merge_Structure_Form = true;
            this.add_edit_Structure = false;
        },
        newParentStructureSelectChanged(selectedItem) 
        {
            if (selectedItem) 
            {
                this.newParentStructure = selectedItem;
                this.newParentStructure_Id = selectedItem.id;
            } else 
            {
                this.newParentStructure = null;
                this.newParentStructure_Id = 0;
            }
        }, 
        CancelDesignatedUser()
        {
            this.AddExternalUser = false;
            this.openOptionPane(12);
        },
        async upsertUser() 
        {
            const dp = this.user;

            if (!dp?.firstName || !dp?.lastName || !dp?.firstNameAr || !dp?.lastNameAr || !dp?.profession || !dp?.professionAr) 
            {
                window.showAlert('res_Msgs_FillRequired', 'warning');
                return;
            }
            
            const isValidEmail = /^((?!@)[\w!#$%&'*+\/=?^_`{|}~-]+(\.[\w!#$%&'*+\/=?^_`{|}~-]+)*)([\w!#$%&'*+\/=?^_`{|}~-]+(\.[\w!#$%&'*+\/=?^_`{|}~-]+)*)?@((?!@)[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*)(\.[a-zA-Z]{2,})$/.test(this.user.email);
                
            if(this.user.email && !isValidEmail&& this.user.email != ""  )
            {
                window.showAlert(this.$t("res_Msgs_InvalidEmail"), 'warning')
                return;
            }
                
            if(!this.user.email)
            {
                this.user.email = '';
            }

            this.user.isDefaultDesignatedPerson = true;

            utils.defaultPost('Document/AddEditDesignatedPerson', this.user,
                (res) => {
                    if (res.data.item1 > 0) {
                        if(res.data.item2 == 1)
                        {
                            window.showAlert('res_Msgs_DesignatedAddSuccess', 'success');
                        }
                        else if(res.data.item2 == 2)
                        {
                            window.showAlert('res_Msgs_DesignatedEditSuccess', 'success');
                        }

                        this.AddExternalUser = false;
                        this.openOptionPane(12);  
                    }
                }, this.handleError, true);},

            validateEmail(email) {

            if (email.trim() === "")
                return false;

            if (!email.includes('@'))
                return false;

            if (email.includes('@@'))
                return false;

            if (/\s/.test(email))
                return false;

            const [localPart, domainPart] = email.split('@');

            if (!localPart || localPart.startsWith('.') || localPart.endsWith('.'))
                return false;

            if (!domainPart || domainPart.startsWith('.') || domainPart.endsWith('.'))
                return false;

            if (!domainPart.includes('.'))
                return false;

            const domainRegex = /^(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)\.)*(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9]))\.([a-zA-Z]{2,})$/;

            const ipRegex = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])$/;

            if (domainRegex.test(domainPart) || ipRegex.test(domainPart))
                return true;
            else
                return false;

            return true;
        },
      }
  }
  </script>
  

<!-- <style> 
.v-dialog.v-dialog--active {
    overflow: visible;
}
</style> -->

<style scoped>
.popup {
    max-width: 400px ; /* Adjust the maximum width of the dialog */
    max-height: 200px;
    margin: auto;
    border-radius: 8px; /* Optional: Add border radius for a rounded appearance */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Optional: Add shadow for depth */
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

label {
    margin-bottom: .5rem;
}

.customTextarea2{ 
    width: 100%;
    border-radius: 8px; 
    background-color: #eff2f5;
    outline: none;
    padding: 10px 19px 10px 15px;
}

</style>